import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { DialogModal, Slot, Text } from '@costar-ui/components';
import { ContactCardSectionGhostDense } from '@costar-ui/info-cards';
import React, { useMemo } from 'react';

var RequestTrainingModalDialog = function RequestTrainingModalDialog(props) {
  var _contact$phone3, _contact$phone4;
  var dialog = props.dialog,
    infoText = props.infoText,
    contact = props.contact,
    triggerElement = props.triggerElement;
  var contactCardProps = useMemo(function () {
    var _contact$name, _contact$jobTitle, _contact$phone, _contact$phone2;
    return {
      name: {
        label: contact === null || contact === void 0 || (_contact$name = contact.name) === null || _contact$name === void 0 ? void 0 : _contact$name.label,
        ellipsis: true
      },
      photo: contact === null || contact === void 0 ? void 0 : contact.photo,
      jobTitle: {
        label: contact === null || contact === void 0 || (_contact$jobTitle = contact.jobTitle) === null || _contact$jobTitle === void 0 ? void 0 : _contact$jobTitle.label
      },
      phone: {
        labels: {
          office: contact === null || contact === void 0 || (_contact$phone = contact.phone) === null || _contact$phone === void 0 || (_contact$phone = _contact$phone.labels) === null || _contact$phone === void 0 ? void 0 : _contact$phone.office
        },
        numbers: {
          office: contact === null || contact === void 0 || (_contact$phone2 = contact.phone) === null || _contact$phone2 === void 0 || (_contact$phone2 = _contact$phone2.numbers) === null || _contact$phone2 === void 0 ? void 0 : _contact$phone2.office
        }
      },
      isLoading: contact === null || contact === void 0 ? void 0 : contact.isLoading
    };
  }, [contact === null || contact === void 0 ? void 0 : contact.isLoading, contact === null || contact === void 0 ? void 0 : contact.jobTitle, contact === null || contact === void 0 ? void 0 : contact.name, contact === null || contact === void 0 || (_contact$phone3 = contact.phone) === null || _contact$phone3 === void 0 || (_contact$phone3 = _contact$phone3.labels) === null || _contact$phone3 === void 0 ? void 0 : _contact$phone3.office, contact === null || contact === void 0 || (_contact$phone4 = contact.phone) === null || _contact$phone4 === void 0 || (_contact$phone4 = _contact$phone4.numbers) === null || _contact$phone4 === void 0 ? void 0 : _contact$phone4.office, contact === null || contact === void 0 ? void 0 : contact.photo]);
  return /*#__PURE__*/React.createElement(DialogModal, {
    title: dialog === null || dialog === void 0 ? void 0 : dialog.heading,
    isOpen: dialog === null || dialog === void 0 ? void 0 : dialog.isOpen,
    size: "std",
    showCloseIcon: true,
    onClose: dialog === null || dialog === void 0 ? void 0 : dialog.onClose,
    actionLabel: dialog === null || dialog === void 0 ? void 0 : dialog.actionLabel,
    cancelLabel: dialog === null || dialog === void 0 ? void 0 : dialog.cancelLabel,
    onAction: dialog === null || dialog === void 0 ? void 0 : dialog.onAction,
    onCancel: dialog === null || dialog === void 0 ? void 0 : dialog.onCancel,
    triggerElement: triggerElement,
    className: "z-[2500]"
  }, /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "4xl",
    testId: "required-training-dialog-content"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "text-16",
    testId: "info-text"
  }, infoText), /*#__PURE__*/React.createElement(ContactCardSectionGhostDense, _extends({}, contactCardProps, {
    testId: "contact-card"
  }))));
};
function StoryRequestTrainingModalDialog(props) {
  return /*#__PURE__*/React.createElement(RequestTrainingModalDialog, props);
}

export { RequestTrainingModalDialog, StoryRequestTrainingModalDialog };
//# sourceMappingURL=request-training-modal-dialog.esm.js.map
